import { parseReference } from "./utils";

export function dataClient({
    axios,
	authAxios,
	service,
    authService,
	logoutUrl,
}) {
	const login = async (usernameOrIdNumberOrUserCode, password, successUrl) => {
		if(!authAxios) return;
		await authAxios
			.post(`${authService?authService:''}/api/login`, {
				login: usernameOrIdNumberOrUserCode,
				password: password,
			})
			.then(async (response) => {
				if (response.status == 200) {
					window.location.href = successUrl?successUrl:"/_profile";
				}
			})
			.catch((error) => {
				if (error.response && error.response.data) {
					if (
						error.response.data.status === "PENDING_PAYMENT" &&
						error.response.data.user &&
						error.response.data.tariff
					) {
						window.location.href = `/_mobile_payment?userId=${error.response.data.user.ref.id}&tariffableReference=${error.response.data.tariff.tariffableReference}&criteriaValue=${error.response.data.tariff.criteriaValue}&sponsor=${encodeURIComponent("SELF")}`;
					} else if (
						error.response.data.status === "OTP" &&
						error.response.data.user
					) {
						window.location.href = `/_change_password?username=${encodeURIComponent(error.response.data.user.name)}`;
					} else if (
						error.response.data.status ===
							"INCOMPLETE_REGISTRATION" &&
						error.response.data.user
					) {
						window.location.href = `/_finish_registration?userId=${error.response.data.user.ref.id}`;
					} else {
						throw new Error(
							error.response.data.error_message &&
								error.response.data.error_message.includes(
									"Bad credentials",
								)
								? "Incorrect username or password"
								: error.message,
						);
					}
				} else {
					throw error;
				}
			});
	};

	const logout = async () => {
		if(!authAxios) return;
		await authAxios.post(`${authService?authService:''}/api/logout`).catch((error) => {
			console.log(error);
		});
		if(logoutUrl)  window.location.href = logoutUrl;
	};

	const getCurrent = async (refresh) => {
		if(!authAxios) return;
		let res = null;
		await authAxios
			.get(`${authService?authService:''}/api/current`)
			.then(async (response) => {
				if(response && response.data) {
					res = response.data;
				}
			})
			.catch(async (error) => {
				if (error.status && error.status >= 400) {
					if ((error.status === 403) && !refresh) {
						await authAxios
							.post(`${authService?authService:''}/api/token/refresh`)
							.then(async (refreshResponse) => {
								if (refreshResponse.status === 200) {
									await getCurrent(true)
									.then((requestData) => {
										res = requestData;
									})
									.catch((err) => {
										res = err
									});
								} else {
									console.log(refreshResponse)
									logout();
								}
							})
							.catch((err) => {
								console.log(err)
								logout();
							});
					} 
				} else if(error.status >= 200 && status.error < 300) {
					res = error.response.data?error.response.data:"";
				} else {
					res = error
				}
			});
		return res;
	};

	const getByReference = async (reference) => {
		let object = null;

		const parsedReference = parseReference(reference);
            
		if (!parsedReference) return;

		await request(
			"GET",
			`${parsedReference.resource}/${parsedReference.id}`,
			null,
			null,
			false,
			parsedReference.baseURL
		)
		.then((response) => {
			if(response && response.ref) {
				object = response
			} 
		})
		.catch((error) => {
			console.log(error);
		})
		return object;
	}

	const sendFormData = async (method, url, formData,params, refresh,baseURL = service && service !== ""?`${service}/api`:"api") => {
		let response = null;
		let fullUrl = baseURL?`${baseURL}/${url}`:url;
		switch (method) {
			case "POST": {
				await axios.post(fullUrl, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(async (postResponse) => {
					await handleResponse(
						method,
						url,
						formData,
						params,
						refresh,
						baseURL,
						postResponse,
					)
					.then((res) => {
						response = res;
					})
				})
				.catch(async (error) => {
					await handleResponse(
						method,
						url,
						formData,
						params,
						refresh,
						baseURL,
						error,
					)
					.then((res) => {
						response = res;
					})
				});
				break;
			}
			case "PUT": {
				await axios.put(fullUrl, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(async (postResponse) => {
					await handleResponse(
						method,
						url,
						formData,
						params,
						refresh,
						baseURL,
						postResponse,
					)
					.then((res) => {
						response = res;
					})
				})
				.catch(async (error) => {
					await handleResponse(
						method,
						url,
						formData,
						params,
						refresh,
						baseURL,
						error,
					)
					.then((res) => {
						response = res;
					})
				});
				break;
			}
		}
		return response;
	}

	const request = async (method, url, body, params, refresh,baseURL = service && service !== ""?`${service}/api`:"api") => {
		let response = null;
		let fullUrl = baseURL?`${baseURL}/${url}`:url;
		switch (method) {
			case "POST": {
				await axios
					.post(fullUrl, body, {
						params: params,
					})
					.then(async (postResponse) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							postResponse,
						)
							.then((res) => {
								response = res;
							})
					})
					.catch(async (error) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							error,
						)
							.then((res) => {
								response = res;
							})
					});
				break;
			}
			case "PUT": {
				await axios
					.put(fullUrl, body, {
						params: params,
					})
					.then(async (putResponse) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							putResponse,
						)
							.then((res) => {
								response = res;
							})
					})
					.catch(async (error) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							error,
						)
							.then((res) => {
								response = res;
							})
					});
				break;
			}
			case "GET": {
				await axios
					.get(fullUrl, {
						params: params,
					})
					.then(async (getResponse) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							getResponse,
						)
							.then((res) => {
								response = res;
							})
					})
					.catch(async (error) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							error,
						)
							.then((res) => {
								response = res;
							})
					});
				break;
			}
			case "DELETE": {
				await axios
					.delete(fullUrl, {
						params: params,
					})
					.then(async (deleteResponse) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							deleteResponse,
						)
						.then((res) => {
							response = res;
						})
					})
					.catch(async (error) => {
						await handleResponse(
							method,
							url,
							body,
							params,
							refresh,
							baseURL,
							error,
						)
						.then((res) => {
							response = res;
						})
					});
				break;
			}
		}
		return response;
	};

	const handleResponse = async (
		method,
		url,
		body,
		params,
		refresh,
		baseURL,
		response,
	) => {
		let data = {};
		if (!response) return data;
		let status = response.status?response.status:response.response && response.response.status?response.response.status:0;
		let code = response.code?response.code:"";
		if (status >= 400 || code) {
			if ((status === 403 || code.includes("ERR_NETWORK")) && !refresh) {
				await authAxios
					.post(`${authService?authService:''}/api/token/refresh`)
					.then(async (refreshResponse) => {
						if (refreshResponse.status === 200) {
							await request(method, url, body, params, true,baseURL)
								.then((requestData) => {
									data = requestData;
								})
								.catch((err) => {
									throw err;
								});
						} else {
							logout();
							throw response;
						}
					})
					.catch((err) => {
						console.log(err)
						logout();
						throw err;
					});
			} else {
				throw response;
			}
		} else if(status >= 200 && status < 300) {
			data = response.data?response.data:"";
		} else {
			throw new Error(
				response.message ? response.message : "Something went wrong!",
			);
		}
		return data;
	};

	const download = async (url, params, refresh,baseURL = service && service !== ""?`${service}/api`:"api") => {
		let data = null;
		let fullUrl = baseURL?`${baseURL}/${url}`:url;
		await axios.get(fullUrl, {
			responseType: "blob",
			params: params,
		})
		.then(async (response) => {
			await handleDownloadResponse(
				url,
				params,
				refresh,
				baseURL,
				response,
			)
			.then((res) => {
				data = res;
			})
		})
		.catch(async (error) => {
			await handleDownloadResponse(
				url,
				params,
				refresh,
				baseURL,
				error,
			)
			.then((res) => {
				data = res;
			})
		});
		return data;
	};

	const handleDownloadResponse = async (
		url,
		params,
		refresh,
		baseURL,
		response,
	) => {
		let data = {};
		if (!response) return data;
		let status = response.status?response.status:response.response && response.response.status?response.response.status:0;
		if (status >= 400) {
			if (status === 403 && !refresh) {
				await authAxios
					.post(`${authService?authService:''}/api/token/refresh`)
					.then(async (refreshResponse) => {
						if (refreshResponse.status === 200) {
							await request(method, url, body, params, true,baseURL)
								.then((requestData) => {
									data = requestData;
								})
								.catch((err) => {
									throw err;
								});
						} else {
							logout();
							throw response;
						}
					})
					.catch((err) => {
						logout();
						throw err;
					});
			} else {
				throw response;
			}
		} else if(status >= 200 && status < 300) {
			data = response;
		} else {
			throw new Error(
				response.message ? response.message : "Something went wrong!",
			);
		}
		return data;
	};

	const errorMessage = (error) => {
		if (error && error.response && error.response.data && error.response.data.message) {
			console.log(error.response.data.message);
			return error.response.data.message;
		} else if (error && error.message) {
			console.log(error.message);
			return error.message;
		} else if(error && typeof error === 'string') {
			console.log(error)
			return error;
		} else {
			let msg = "Something went wrong!"
			console.log(msg);
			return msg;
		}
	}

	return {
		login: login,
		logout: logout,
		request: request,
		sendFormData: sendFormData,
		download: download,
		getCurrent: getCurrent,
		getByReference: getByReference,
		errorMessage: errorMessage
	};
}